export const getCustomerStatus = (state) => state.customerStatus
